import React from 'react';
import PropTypes from 'prop-types';
import { Loading } from 'carbon-components-react';
import Utils from 'utilities/helper.util';

const ButtonContent: React.FC<Props> = ({ children, isLoading, icon }: any) => (
  <>
    {children}{' '}
    {isLoading ? (
      <Loading
        small
        description="Active loading indicator"
        withOverlay={false}
      />
    ) : (
      !Utils.isObjectEmpty(icon) && icon
    )}
  </>
);

const propTypes = {
  isLoading: PropTypes.bool.isRequired,
  icon: PropTypes.object
};

type Props = PropTypes.InferProps<typeof propTypes>;

ButtonContent.propTypes = propTypes;

ButtonContent.defaultProps = {
  isLoading: false,
  icon: {}
};

export default ButtonContent;
